import type { Address } from '@/shared/api/resources';

/**
 * O endereco do tomador numa linha, como o passo "Dados do tomador" e o Resumo da
 * cotacao do OnPoint mostram (NCT-090 e NCT-166): rua e numero, complemento, bairro,
 * cidade e UF e o CEP. Sem endereco cadastrado, diz isso.
 */
export function enderecoDoTomador(endereco: Address | null | undefined): string {
  if (!endereco) return 'Endereco nao cadastrado';
  const rua = [endereco.street, endereco.number].filter(Boolean).join(', ');
  const cidade = [endereco.city, endereco.state].filter(Boolean).join('/');
  const cep = endereco.zip_code ? `CEP ${formatarCep(endereco.zip_code)}` : '';
  const linha = [rua, endereco.complement, endereco.district, cidade, cep]
    .filter(Boolean)
    .join(' - ');
  return linha || 'Endereco nao cadastrado';
}

function formatarCep(cep: string): string {
  const digitos = cep.replace(/\D/g, '');
  return digitos.length === 8 ? `${digitos.slice(0, 5)}-${digitos.slice(5)}` : cep;
}
